export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'before_text',
		label: 'Before Text',
		selector: '& .before-text'
	},
	{
		name: 'label',
		label: 'Time Label',
		selector: '& .counter .label'
	},
	{
		name: 'time',
		label: 'Time',
		selector: '& .counter .time'
	},
	{
		name: 'after_text',
		label: 'After Text',
		selector: '& .after-text'
	}
]